import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import http from './utils/http'
Vue.prototype.$axios = http

import login from './utils/login'
Vue.use(ElementUI);
Vue.config.productionTip = false;


router.beforeEach((to, from, next) => {
  if(typeof (store.state.user_id) == "undefined"){
    // login
    login()
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
